<template id="vTable">
  <div>
    <v-card id="cardShop">

      <v-data-table
        :headers="headers"
        :items="desserts"
        loading-text="در حال بروز رسانی. لطفا اندکی صبر کنید"
        class="elevation-1 mytable"
        @update:options="updateTable($event)"
        :server-items-length="rowCount"
      >
        <template v-slot:top>
          <v-toolbar
            flat
          >
            <v-toolbar-title style="font-family: anjoman!important;font-weight: normal!important;">تماس با ما</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog
              v-model="dialog"
              max-width="500px"
            >
              <v-card>
                <v-card-title>
                  <span style="font-family: anjoman!important;font-weight: normal!important;" class="headline">مشاهده جزئیات</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <div class="colFlex" >
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="fontanjoman">تاریخ</span>
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="border_box">{{convertTime(editedItem.time)}}</span>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <div class="colFlex" >
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="fontanjoman">نام و نام خاانوادگی</span>
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="border_box">{{editedItem.name}}</span>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <div class="colFlex" >
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="fontanjoman">تعیین وضعیت</span>
                          <div style="display: flex;">
                            <v-chip style="font-family: anjoman!important;font-weight: normal!important; width: 130px; justify-content: center;"  dark :color="editedItem.solved ? 'green' : 'red'">
                              {{solvedFunc(editedItem.solved)}}
                            </v-chip>
<!--                            <span class="border_box" v-text="solvedFunc(editedItem.solved)"></span>-->
                            <v-btn :loading="acceptLoading" style="font-family: anjoman!important;font-weight: normal!important; width: 50px; height: 20px;" :disabled="editedItem.solved" @click="putMessageFunc(editedItem.id, editedItem.category)">تایید</v-btn>

                          </div>
                        </div>

                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <div class="colFlex" >
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="fontanjoman">موضوع</span>
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="border_box">{{subjectMessage(editedItem.category)}}</span>
                        </div>

                      </v-col>

                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <div class="colFlex" >
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="fontanjoman">شماره تلفن</span>
                          <div style="display: flex;">
                            <span style="font-family: anjoman!important;font-weight: normal!important;" v-if="editedItem.phoneNo !== null" class="border_box">{{returnFarsiNumber(editedItem.phoneNo)}}</span>
                          </div>
                        </div>

                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <div class="colFlex" >
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="fontanjoman">ایمیل</span>
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="border_box">{{editedItem.eMail}}</span>
                        </div>

                      </v-col>


                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <div class="colFlex" >
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="fontanjoman">پیام</span>
                          <span style="font-family: anjoman!important;font-weight: normal!important;" class="border_box">{{editedItem.text}}</span>
                        </div>
                      </v-col>

                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#E72480"
                    text
                    @click="close"
                    style="font-family: anjoman!important;font-weight: normal!important;"
                  >
                    بستن
                  </v-btn>
                </v-card-actions>
              </v-card>
              <v-form v-model="valid">
                <v-card>
                  <v-card-title>
                    <span style="font-family: anjoman!important;font-weight: normal!important;" class="headline">ارسال پیام</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                        >
                          <div class="colFlex" >
                            <span style="font-family: anjoman!important;font-weight: normal!important;" class="fontanjoman">متن پیام</span>
                            <v-textarea style="font-family: anjoman!important;font-weight: normal!important;" v-model="replyMessage.replyText" :rules="textRules" outlined></v-textarea>
                          </div>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                        >
                          <v-checkbox style="font-family: anjoman!important;font-weight: normal!important;" label="ارسال پیام به شماره" v-model="replyMessage.bySMS"></v-checkbox>
<!--                          <v-checkbox disabled label="ارسال پیام به ایمیل" ></v-checkbox>-->
                        </v-col>
                      </v-row>

                    </v-container>

                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="#E72480"
                      text
                      @click="replyMessageFunc"
                      :disabled="!valid"
                      :loading="messageLoading"
                      style="font-family: anjoman!important;font-weight: normal!important;"
                    >
                      ارسال
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title style="font-family: anjoman!important;font-weight: normal!important;" class="headline">آيا از حذف این پیام مطمئن می‌باشید؟</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn style="font-family: anjoman!important;font-weight: normal!important;" color="#E72480" text @click="closeDelete">لغو</v-btn>
                  <v-btn style="font-family: anjoman!important;font-weight: normal!important;" color="#E72480" :loading="deleteLoading" text @click="deleteItemConfirm">تایید</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn    @click="editItem(item)" class="ml-2" text plain elevation="2" icon>
            <v-icon
              small
              color="blue"

            >
              mdi-eye
            </v-icon>
          </v-btn>
          <v-btn             @click="deleteItem(item)"
                             text plain elevation="2" icon>
          <v-icon
            small
            color="red"
          >
            mdi-delete
          </v-icon>
          </v-btn>
        </template>
        <template v-slot:item.time="{item}">
          <span>
            {{convertTime(item.time)}}
          </span>
        </template>
        <template v-slot:item.solved="{item}">
          <v-chip outlined :color="item.solved ? 'green' : 'red'">
            {{solvedFunc(item.solved)}}
          </v-chip>
        </template>
        <template v-slot:item.category="{item}">
        <span>
          {{subjectMessage(item.category)}}
        </span>
        </template>


        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="getMessagesData"
          >
            تنظیم مجدد
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {deleteMessage, putMessage} from "../../../api/contacts"
import {mapActions, mapGetters} from "vuex";
import * as moment from "jalali-moment";
import {toFarsiNumber} from "../../../plugins/toFarsiNumber";

export default {
  name: "contact",
  data: () => ({
    acceptLoading:false,
    deleteLoading:false,
    messageLoading:false,
    progressBar: true,
    rowCount: null,
    res : null,
    page:1,
    pagesSize:5,
    dialog: false,
    dialogDelete: false,
    imageFile:null,
    headers: [
      { text: 'تاریخ', value: 'time' ,sortable: false, },
      {
        text: 'نام و نام خانوادگی',
        align: 'start',
        value: 'name',
      },
      { text: 'موضوع', value: `category` },
      { text: 'پیام', value: 'text' ,sortable: false, },
      { text: 'وضعیت', value: 'solved' ,sortable: false, },
      { text: 'مشاهده - حذف', value: 'actions', sortable: false,width:'150' },
    ],
    valid: true,
    desserts: [],
    editedItem: {
      id: 0,
      name: '',
      text: '',
      category: null,
      time:null,
      solved: null,
      eMail: null,
      phoneNo: null,

    },
    url: process.env.VUE_APP_BASE_URL,
    perPage: null,
    defaultItem: {
      id: 0,
      name: '',
      text: '',
      category: null,
      time:null,
      solved: null,
      eMail: null,
      phoneNo: null,

    },
    replyMessage: {
      messageId: null,
      replyText: null,
      bySMS : false

    },
    textRules: [
      v => !!v || 'لطفا پیام خود را وارد نمایید'
    ],
  }),
  computed:{
    ...mapGetters({
      getMessage: 'contactInfoStore/get_contactMessage'
    }),
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },
  mounted () {
    this.getMessagesData()
  },
  methods: {
    ...mapActions({
      snackBarAction: 'snackBar/snackBarAction',
      fetchMessage: 'contactInfoStore/fetchContactMessage',
      postReply: 'contactInfoStore/postReplyAction',
      setLoading : 'setLoading'

    }),
    async getMessagesData () {
      await this.refresh()
      this.progressBar=  false
    },

    async deleteItemConfirm () {
      this.deleteLoading = true
      try {
        await deleteMessage(this.editedItem.id)
        this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات حذف با موفقیت اعمال شد', showSnackbar:true})
      }
      catch{
        this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
      }
      await this.refresh()
      this.closeDelete()
      this.deleteLoading = false
    },





    editItem (item) {

      this.editedItem = Object.assign({}, item)

      this.dialog = true
    },

    deleteItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      })
    },

    async refresh(){
      this.setLoading(true);
      try{
        await this.fetchMessage ({page: this.page , pageSize: this.pagesSize});
        this.res = await this.getMessage;
        this.desserts = this.res.results
        this.rowCount = this.res.rowCount
      }
      catch (error) {
        // console.log('er:', error);
      }
      finally {
        this.setLoading(false);

      }
    },
    async updateTable ( changeTableEvent){
      this.page = changeTableEvent.page;
      this.pagesSize = changeTableEvent.itemsPerPage;
      await this.refresh()
    },
    subjectMessage(val) {
      switch (val) {
        case 1 : return 'پیشنهاد';
        case 2 : return 'انتقاد';
        case 3 : return 'شکایت';
        case 4 : return 'مدیریت';
        case 5 : return 'موضوعات دیگر';
      }
    },
    convertTime(inp){
      try {
        let l;
        l = moment(inp).locale('fa').format('YYYY/M/D');
        return  l
      }
      catch (e) {

        // console.log('ای بابا دوباره خطا داد', e);
      }
    },
    solvedFunc(val){
      if (val == true){
        return 'تایید'
      }
      else
        return 'عدم تایید'
    },
    async putMessageFunc(id , cat){
      this.acceptLoading = true
      try {
        await putMessage(id , {id: id, solved:true, category:cat});
        await this.refresh();
        this.editedItem.solved = true;
        this.solvedFunc(true)
      }
      catch{
        //
      }
      this.acceptLoading  = false
    },
    returnFarsiNumber(val){
      return toFarsiNumber(val);
    },
    async replyMessageFunc(){
      this.messageLoading = true
      this.replyMessage.messageId = this.editedItem.id;
      try {
        await this.postReply(this.replyMessage);
        this.snackBarAction({color:"#4CAF50" , textSnackBar:'فرستادن پیام با موفقیت انجام شد', showSnackbar:true})
      }
      catch(e) {
        this.snackBarAction({color:"#ff5252" , textSnackBar:'فرستادن پیام انجام نشد', showSnackbar:true})
      }
      await this.refresh();
      this.close();
      this.messageLoading = false
    }
  },
}
</script>
<style scoped>
#cardShop{
  width: 86.5%;
  margin: 0 auto;
}
  .colFlex{
   display: flex;
    flex-direction: column;
  }
  .fontanjoman{
    font-family: anjoman;
    font-size: 1rem;
  }
  .border_box{
    border: 1px gray solid;
    width: 100%;
    min-height: 30px;
    padding-right: 5px;
  }

</style>
